<template>
  <div class="text-textColor overflow-hidden">
    <transition name="fade">
      <div v-if="showEmployeeDetails" class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-hidden">
        <form
              class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full p-2">
          <transition name="fade">
            <div v-if="loading" class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full">
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">{{ decryptDataLocal(employeeDetails.Fullname, decryptionKey) }} </p>
            <img class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                 src="@/assets/icons/cross-white.png" @click="close()" />
          </div>
          <div class="grid grid-cols-1 xl:grid-cols-2 md:grid-cols-2 gap-4 mt-2">
            <div class="text-sm">
              <label class="block pb-1">
                Full name
              </label>
              <input
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Start Date"
                  disabled
                  :value="decryptDataLocal(employeeDetails.Fullname, decryptionKey)"
              />
            </div>
            <div class="text-sm" >
              <label class="block pb-1">
                Email
              </label>
              <input
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Email"
                  disabled
                  :value="decryptDataLocal(employeeDetails.Email, decryptionKey)"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">
                Role
              </label>
              <input
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Role"
                  required
                  disabled
                  :value="employeeDetails.RoleName"
              />
            </div>
            <div class="text-sm" >
              <label class="block pb-1">
                Department

              </label>
              <input
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="End Date"
                  disabled
                  :value="employeeDetails.EmployeeDepartments.length > 0 ? employeeDetails.EmployeeDepartments[0].Department : 'N/A'"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">
                Date joined

              </label>
              <input
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Start Date"
                  disabled
                  :value="new Date(employeeDetails.DateOfJoining).toLocaleDateString()"
              />
            </div>
            <div class="text-sm" >
              <label class="block pb-1">
               Employment type

              </label>
              <input
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Employment Type"
                  disabled
                  :value="employeeDetails.EmploymentType ? employeeDetails.EmploymentType : 'N/A'"
              />
            </div>
            <div class="text-sm" >
              <label class="block pb-1">
               Branch / Location

              </label>
              <input
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="End Date"
                  disabled
                  :value="employeeDetails.EmployeeDepartments.length > 0 ? employeeDetails.EmployeeDepartments[0].Branch : 'N/A'"
              />

            </div>
          </div>

          <!--  @change="handleDescriptionChange" -->
          <div class="flex justify-end p-5 gap-5">
            <button @click="close()" class="bg-primary rounded-full px-10 text-sm text-white py-2">
              Close
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>
<script>
import decryptData from "@/utils/decrypt";

export default {
  name:"PreviewEmployeeDetails",
  props: ["showEmployeeDetails", "employeeDetails"],
  data(){
    return {
      loading:false,
      decryptDataLocal: "",
    }
  },
  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
  },
  methods: {
    close() {
      this.$emit("close");
    },
  }
}
</script>